import React, { useEffect, useState, useCallback } from 'react';
import { Menu, X } from 'lucide-react';
import { profile } from '../mock';

const LINKS = [
  { label: 'About', href: '#about' },
  { label: 'Skills', href: '#skills' },
  { label: 'Experience', href: '#experience' },
  { label: 'Clients', href: '#clients' },
  { label: 'Domains', href: '#domains' },
  { label: 'Certifications', href: '#certifications' },
  { label: 'Contact', href: '#contact' },
];

const getInitials = (name) =>
  name
    .split(' ')
    .map((n) => n[0])
    .join('');

const DesktopNav = ({ email }) => (
  <nav className="hidden lg:flex items-center gap-9">
    {LINKS.map((l) => (
      <a
        key={l.href}
        href={l.href}
        className="text-sm text-white/80 hover:text-[#c9a961] transition-colors duration-200 tracking-wide"
      >
        {l.label}
      </a>
    ))}
    <a
      href={`mailto:${email}`}
      className="text-sm font-medium border border-[#c9a961] text-[#c9a961] px-4 py-2 hover:bg-[#c9a961] hover:text-[#07111f] transition-colors"
    >
      Get in touch
    </a>
  </nav>
);

const MobileMenu = ({ email, onClose }) => (
  <div className="lg:hidden bg-[#07111f] border-t border-white/10">
    <div className="px-6 py-6 flex flex-col gap-4">
      {LINKS.map((l) => (
        <a
          key={l.href}
          href={l.href}
          onClick={onClose}
          className="text-white/85 hover:text-[#c9a961] text-sm tracking-wide"
        >
          {l.label}
        </a>
      ))}
      <a
        href={`mailto:${email}`}
        className="mt-2 inline-block self-start text-sm border border-[#c9a961] text-[#c9a961] px-4 py-2"
      >
        Get in touch
      </a>
    </div>
  </div>
);

const Brand = ({ name, initials }) => (
  <a href="#top" className="flex items-center gap-3 group">
    <div className="w-10 h-10 border border-[#c9a961] text-[#c9a961] flex items-center justify-center font-display text-base group-hover:bg-[#c9a961] group-hover:text-[#07111f] transition-colors">
      {initials}
    </div>
    <div className="hidden sm:block">
      <div className="text-white font-display text-base leading-tight">{name}</div>
      <div className="text-[10px] tracking-[0.3em] uppercase text-[#c9a961]">Technical Lead</div>
    </div>
  </a>
);

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  const onScroll = useCallback(() => {
    setScrolled(window.scrollY > 24);
  }, [setScrolled]);

  useEffect(() => {
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [onScroll]);

  const toggleMenu = () => setOpen((v) => !v);
  const closeMenu = () => setOpen(false);

  const initials = getInitials(profile.name);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? 'bg-[#07111f]/95 backdrop-blur border-b border-white/10' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-4 flex items-center justify-between">
        <Brand name={profile.name} initials={initials} />
        <DesktopNav email={profile.email} />
        <button
          onClick={toggleMenu}
          className="lg:hidden text-white p-2"
          aria-label="Toggle menu"
          type="button"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>
      {open ? <MobileMenu email={profile.email} onClose={closeMenu} /> : null}
    </header>
  );
};

export default Navbar;
